import { AnimaticState } from '@crossnokaye/ux-animatics';

import { AnimaticPrimitiveConfigStatus, LabelConfigVariant } from '@repo/sdk/models/components';

import {
  ANIMATIC_ESTOPPED,
  ANIMATIC_FAULTED,
  ANIMATIC_OFF,
  ANIMATIC_ON,
} from './animatics.constants';

export {
  getAnimaticLabels,
  getBannerLabel,
  getLabel,
  parseLabelRef,
} from './animatics.labels.helpers';

export const parseState = (state: AnimaticPrimitiveConfigStatus | undefined): AnimaticState => {
  switch (state) {
    case AnimaticPrimitiveConfigStatus.On:
      return ANIMATIC_ON;
    case AnimaticPrimitiveConfigStatus.Off:
      return ANIMATIC_OFF;
    case AnimaticPrimitiveConfigStatus.Faulted:
      return ANIMATIC_FAULTED;
    case AnimaticPrimitiveConfigStatus.Estopped:
      return ANIMATIC_ESTOPPED;
    default:
      return ANIMATIC_ON;
  }
};

export const bannerVariantTextClassName = (variant?: LabelConfigVariant): string => {
  switch (variant) {
    case LabelConfigVariant.EstoppedBanner:
      return 'text-ckds-text-fg-destructive';
    case LabelConfigVariant.FaultedBanner:
      return 'text-ckds-text-fg-default';
    default:
      return 'text-primary';
  }
};

export const bannerVariantBackgroundClassName = (variant?: LabelConfigVariant): string => {
  switch (variant) {
    case LabelConfigVariant.FaultedBanner:
      return 'bg-ckds-base-critical/90';
    case LabelConfigVariant.EstoppedBanner:
    default:
      return 'bg-secondary/90';
  }
};
